import { useState } from "react"

import { Flex, Form } from "antd"
import { useTranslation } from "react-i18next"

import TypesDropdown from "../../Containers/PersonalSettings/PublicAPI/components/Modals/TypesDropdown"
import Icon from "../../Icon"
import ButtonComponent from "../Button"
import InputComponent from "../Input"

function AddEnpointForm({ error, close, onSubmitAddEnpointForm, eventTypeOptions, ...props }) {
  const [form] = Form.useForm()
  const { t } = useTranslation()

  const [selectedTypes, setSelectedTypes] = useState([])

  const onFinish = (values) => {
    const data = {
      ...values,
      event_types: selectedTypes
    }
    // console.log('onfinish', data)
    onSubmitAddEnpointForm(data)
  }

  function handleClearError(e, field) {
    form.setFields([
      {
        name: field,
        errors: []
      }
    ])
  }

  function onFocusHandler(e, fieldName) {
    const field = fieldName || e.target.name || e.target.id
    handleClearError(e, field)
  }

  const addErrorIcon = (error) => (
    <span>
      <Icon type={"alert_triangle_error"} /> {error}
    </span>
  )

  const validateMessages = {
    required: addErrorIcon("Required fields were not filled.")
  }

  const validateUrl = (_, value) => {
    if (!value) return Promise.resolve()

    const trimmed = value.trim()

    try {
      const url = new URL(trimmed)

      if (url.protocol !== "https:") {
        return Promise.reject(new Error("Only HTTPS URLs are allowed"))
      }

      if (!url.pathname || url.pathname === "/") {
        return Promise.reject(new Error("URL must contain a path"))
      }
    } catch (error) {
      return Promise.reject(new Error("Invalid URL format"))
    }

    return Promise.resolve()
  }

  const handleTypesChange = (newTypes) => {
    setSelectedTypes(newTypes)
    form.setFieldValue("event_types", newTypes) // Update form field value to trigger validation
  }

  return (
    <Form
      className={"with-default-error"}
      onFinish={onFinish}
      validateTrigger="onSubmit"
      validateMessages={validateMessages}
      layout="vertical"
      form={form}
      initialValues={{ event_types: [] }}
    >
      <Form.Item
        name="callback_url"
        label={t("Callback URL")}
        rules={[{ required: true }, { validator: validateUrl }]}
      >
        <InputComponent
          //placeholder="Enter a new pricing scheme name"
          name="url"
          onFocus={onFocusHandler}
        />
      </Form.Item>

      <Form.Item name="event_types" label={t("Event type")} rules={[{ required: true }]}>
        <TypesDropdown
          types={eventTypeOptions}
          onTypesChange={handleTypesChange}
          selectedTypes={selectedTypes}
        />
      </Form.Item>

      <Flex gap={16} justify="end" style={{ margin: "38px 0 5px" }}>
        <ButtonComponent size="large" htmlType="button" onClick={close}>
          {t("Cancel")}
        </ButtonComponent>

        <ButtonComponent size="large" type="primary" htmlType="submit">
          {t("Add")}
        </ButtonComponent>
      </Flex>
    </Form>
  )
}

export default AddEnpointForm
